module.exports = "/virtual-football-league/img/amblems/right/logos/Hertha.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Hertha.png
// module id = 2201
// module chunks = 4